import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    const selectors = [
      ".dashboard-content",
      ".dashboard-body",
      ".main-content",
      ".page-content",
      ".content-wrapper"
    ];

    selectors.forEach((selector) => {
      const el = document.querySelector(selector);
      if (el) {
        el.scrollTop = 0;
      }
    });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;